import { Input } from '@/components/ui/input';
import { useUploadContextFactory } from '../upload-contexts/use-upload-context-factory';

const FileUpload = ({ contextType }) => {
  const { handleFileUpload, CustomFileUploadRender = null } = useUploadContextFactory({
    contextType,
  });

  const handleFileInputChange = event => {
    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onload = e => {
      const text = e.target.result;
      // Split into lines and remove empty lines
      const lines = text
        .split('\n')
        .map(line => line.trim())
        .filter(line => line.length > 0);

      const parseCSVLine = line => {
        const cells = [];
        let cell = '';
        let inQuotes = false;
        for (let i = 0; i < line.length; i++) {
          const char = line[i];
          if (char === '"') {
            if (inQuotes && line[i + 1] === '"') {
              // Handle escaped quotes ("")
              cell += '"';
              i++; // Skip the next quote
            } else {
              // Toggle quote state
              inQuotes = !inQuotes;
            }
          } else if (char === ',' && !inQuotes) {
            // End of cell
            cells.push(cell.trim());
            cell = '';
          } else {
            cell += char;
          }
        }

        // Add the last cell
        cells.push(cell.trim());
        return cells;
      };
      const rows = lines.map(parseCSVLine);
      const headers = rows[0];
      const dataRows = rows.slice(1).filter(row => row.some(cell => cell.length > 0));

      handleFileUpload({ headers, rows: dataRows });
    };

    reader.readAsText(file);
  };

  return (
    <>
      {CustomFileUploadRender && <CustomFileUploadRender />}
      <Input
        id="upload"
        className="w-72 cursor-pointer"
        type="file"
        name="file"
        accept=".csv"
        onChange={handleFileInputChange}
      />
    </>
  );
};

export default FileUpload;
